import withPrefix from '../../strings/withPrefix';

export const PREFIX = 'category-';

const categoryPath = (slug: string): string => {
    return withPrefix(PREFIX, slug);
};

export default categoryPath;
